export const tutorOne2OneUpdateLoading =  ({store})  => store.tutorSessionOne2OneUpdateReducer.loading;

export const tutorOne2OneUpdateError =  ({store})  => store.tutorSessionOne2OneUpdateReducer.error;

export const tutorOne2OneUpdateData =  ({store})  => store.tutorSessionOne2OneUpdateReducer.data;